import { sliceName, initialState } from './slice';

/**
 * Direct selector to the locationPage state domain
 */

const selectLocationPageDomain = (state) => state[sliceName] ?? initialState;

export { selectLocationPageDomain };
